import axios from "axios";

class ApiService {
  // Khi server từ chối xác thực (401/403), xóa phiên và đưa về /login
  // thay vì để thao tác thất bại im lặng.
  static handleAuthError(status) {
    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      localStorage.removeItem('userName');
      if (window.location.pathname.indexOf('/login') === -1) {
        window.location.href = '/login';
      }
    }
  }

  // Method to handle API calls
  static async getDataWithParams(url, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const fullUrl = `${url}?${queryString}`;

    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(fullUrl, { headers });
      if (!response.ok) {
        ApiService.handleAuthError(response.status);
        const err = new Error('Request failed');
        err.httpStatus = response.status;
        throw err;
      }
      const text = await response.text();
      return text ? JSON.parse(text) : {};
    } catch (error) {
      throw error;
    }
  }

  /**
* Post data to a URL with a JSON body
* @param {string} url - The API endpoint URL
* @param {Object} body - The payload to send in the POST request
*/
  static async postData(url, body = {}) {
    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        ApiService.handleAuthError(response.status);
        const err = new Error('Request failed');
        err.httpStatus = response.status;
        throw err;
      }
      const text = await response.text();
      return text ? JSON.parse(text) : {};
    } catch (error) {
      throw error;
    }
  }

  /**
   * Post data to a URL with FormData
   * @param {string} url - The API endpoint URL
   * @param {FormData} formData - FormData to send in the POST request
   */
  static async postFormData(url, data) {
    const token = localStorage.getItem('token');
    // NOTE: Do NOT set Content-Type manually. axios generates the correct
    // multipart/form-data boundary for FormData bodies automatically.
    const headers = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await axios.post(url, data, { headers });
      return response.data;
    } catch (error) {
      // Surface HTTP errors instead of returning the error body as if it were a
      // successful result (which caused false "success" messages). Callers must
      // treat a thrown error / non-success response as a failure.
      const err = new Error('Request failed');
      err.httpStatus = error.response ? error.response.status : null;
      err.data = error.response ? error.response.data : null;
      ApiService.handleAuthError(err.httpStatus);
      throw err;
    }
  }

  // DELETE
  static async deletePost(url = {}) {
    const token = localStorage.getItem('token');
    const headers = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(url, {
        method: 'Delete',
        headers: headers
      });

      if (!response.ok) {
        ApiService.handleAuthError(response.status);
        const err = new Error('Request failed');
        err.httpStatus = response.status;
        throw err;
      } else {
        // alert("Xóa thành công")
      }
      const text = await response.text();
      return text ? JSON.parse(text) : {};
    } catch (error) {
      throw error;
    }
  }

  /**
   * Put data to a URL with a JSON body
   * @param {string} url - The API endpoint URL
   * @param {Object} body - The payload to send in the PUT request
   */
  static async putData(url, body = {}) {
    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        ApiService.handleAuthError(response.status);
        const err = new Error('Request failed');
        err.httpStatus = response.status;
        throw err;
      }
      const text = await response.text();
      return text ? JSON.parse(text) : {};
    } catch (error) {
      throw error;
    }
  }

}

export default ApiService;
